// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__3e2hs","checkBox":"Checkbox_checkBox__YfgO7"};